"use strict";

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

const BufferList = require('bl/BufferList');

const TypeDefault = {
  string: () => '',
  buffer: () => BufferList()
};

module.exports = async (source, options) => {
  options = options || {};

  if (options.type && !TypeDefault[options.type]) {
    throw new Error("invalid type \"".concat(options.type, "\""));
  }

  let res, type;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;

  var _iteratorError;

  try {
    for (var _iterator = _asyncIterator(source), _step, _value; _step = await _iterator.next(), _iteratorNormalCompletion = _step.done, _value = await _step.value, !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
      const chunk = _value;

      if (!res) {
        type = options.type || typeof chunk === 'string' ? 'string' : 'buffer';
        res = TypeDefault[type]();
      }

      if (type === 'string') {
        res += chunk;
      } else {
        res.append(chunk);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        await _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return res || TypeDefault[options.type || 'buffer']();
};